import React from 'react'
import { NavLink } from 'react-router-dom'
import './AppNavbar.css'
import HomeIcon from '@mui/icons-material/Home'
function AppNavbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white " >
     <HomeIcon/>
  <NavLink className="navbar-brand " to="/school">Warwi</NavLink>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav mr-auto">
      <li className="nav-item active">
        <NavLink className="nav-link" to="/school">Nos formations agricoles<span className="sr-only">(current)</span></NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/school">Notre Campus</NavLink>
      </li>
      <li class="nav-item dropdown">
        <NavLink className="nav-link " to="/school" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Inscription et Préinscription
        </NavLink>
       
      </li>
      
    </ul>
    <form className="form-inline my-2 my-lg-0">
      <input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>
      <button className="btn btn-outline-primary my-2 my-sm-0" type="submit">Search</button>
    </form>
  </div>
</nav>
  )
}

export default AppNavbar